import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { getLoginRedirectPath } from "./redux/common";

const PrivateRoute = ({ loggedIn, hasPendingTerms, ...props }) => {
  const requiresTermsRedirect =
    loggedIn && hasPendingTerms && props.path !== "/terms-accept";

  return (
    <Route
      path={props.path}
      exact={props.exact}
      component={
        loggedIn
          ? requiresTermsRedirect
            ? () => <Redirect to="/terms-accept" />
            : props.component
          : () => <Redirect to={getLoginRedirectPath()} />
      }
    />
  );
};

const mapStateToProps = (state) => ({
  loggedIn: state.loggedIn,
  hasPendingTerms: Array.isArray(state.pendingTerms)
    ? state.pendingTerms.length > 0
    : false,
});
const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(PrivateRoute);
